const routes = [{
  path: '/deviceManage',
  component: () => import('@/views/instantAssistance/deviceManage'),
  name: 'device-manage',
  meta: {
    title: '设备管理'
  }
}, {
  path: '/accidentMonitor',
  component: () => import('@/views/instantAssistance/accidentMonitor'),
  name: 'accident-monitor',
  meta: {
    title: '事故监控'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/instantAssistance.js